"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignmentEvidenceClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const user_assignment_evidence_serializer_1 = require("../serializers/user-assignment-evidence.serializer");
const form_data_1 = __importDefault(require("form-data"));
const sdk_constants_1 = require("../../constants/sdk.constants");
class UserAssignmentEvidenceClient {
    constructor(client, serializer, presignedURLClient) {
        this.client = client;
        this.serializer = serializer;
        this.presignedURLClient = presignedURLClient;
    }
    static newInstance(options, retryOptions) {
        return new UserAssignmentEvidenceClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new user_assignment_evidence_serializer_1.UserAssignmentEvidenceSerializer(), dp_http_client_lib_1.RetryableHttpClient.newInstance({ baseURL: '' }, retryOptions));
    }
    async findByUserAssignment(userAssignmentId, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.findByUserAssignment/${userAssignmentId}`, {
            headers,
        });
        return this.serializer.serialize(response.body);
    }
    async deleteByUserAssignment(userAssignmentId, deleteReason, headers) {
        await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.deleteByUserAssignment`, {}, {
            headers,
            params: {
                userAssignmentId,
                deleteReason,
            },
        });
    }
    async deleteByContentId(contentIds, headers) {
        const response = await this.client.delete(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.deleteByContentId`, {
            headers,
            params: {
                contentId: contentIds,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async deleteById(evidenceId, headers) {
        await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.deleteById/${evidenceId}`, {}, {
            headers,
        });
    }
    async replace(contentId, file, headers = {}) {
        const data = new form_data_1.default();
        data.append('file', file);
        const response = await this.client.put(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.replace`, data, {
            headers,
            params: {
                contentId,
            },
        });
        return this.serializer.serializeOne(response.body);
    }
    async upload(userAssignmentId, files, resourceId, headers = {}) {
        const data = new form_data_1.default();
        for (const file of files) {
            data.append('files', file);
        }
        const response = await this.client.post(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.upload`, data, {
            headers,
            params: {
                userAssignmentId,
                resourceId,
            },
        });
        return this.serializer.serialize(response.body);
    }
    async download(evidenceId, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.download/${evidenceId}`, {
            headers,
        });
        const { presignedUrl } = response.body.data;
        const result = await this.presignedURLClient.get(presignedUrl, {
            responseType: 'arraybuffer',
        });
        return result.body;
    }
    async downloadByUserAssignment(userAssignmentId, assigneeName, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.downloadByUserAssignment`, {
            headers,
            params: {
                userAssignmentId,
                assigneeName,
            },
            responseType: 'arraybuffer',
        });
        return response.body;
    }
    async downloadByAssignment(assignmentId, headers) {
        const response = await this.client.get(`${sdk_constants_1.API_PREFIX}/userAssignmentEvidences.downloadByAssignment`, {
            headers,
            params: {
                assignmentId,
            },
        });
        if (response.body.data.presignedUrl !== undefined) {
            const { presignedUrl } = response.body.data;
            const result = await this.presignedURLClient.get(presignedUrl, {
                responseType: 'arraybuffer',
            });
            return result.body;
        }
        return response.body;
    }
}
exports.UserAssignmentEvidenceClient = UserAssignmentEvidenceClient;
//# sourceMappingURL=user-assignment-evidence.client.js.map